import http from '../common/http-common'

class ConsultasServices {
  getPedimentoContent(
    Referencia: string,
    Folio: string,
    Pedimento: string,
    NoCliente: string,
    Patente: string,
    Aduana: string
  ) {
    return http
      .get<ArrayBuffer>(
        `/Consultas/PedimentoPdfGet?Referencia=${Referencia}&Folio=${Folio}&Pedimento=${Pedimento}&NoCliente=${NoCliente}&Patente=${Patente}&Aduana=${Aduana}`,
        {
          responseType: 'arraybuffer'
        }
      )
      .then(function (response) {
        return response
      })
      .catch(function (error) {
        console.log(error)
      })
  }
}

export default new ConsultasServices()
